import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {connect} from 'react-redux'
import Button from '@mui/material/Button';
import i18n from "../../../i18nSetup";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';


import {
  OTP_API_DATE_FORMAT,
  OTP_API_TIME_FORMAT,
  getTimeFormat,
  getDateFormat
} from '../../@opentripplanner/core-utils/src/time'
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";

function DateTimePreview(props) {

  const {
    caret,
    date,
    editButtonText,
    time,
    departArrive,
    routingType,
    startTime,
    endTime,
    timeFormat,
    dateFormat,
    isPopoverOpened
    } = props;

    let timeStr;
    const formattedTime = moment.utc(time, OTP_API_TIME_FORMAT).format(timeFormat)
    if (routingType === 'ITINERARY') {
      if (departArrive === 'NOW') timeStr = i18n.t('leaveNow')
      else if (departArrive === 'ARRIVE') timeStr = i18n.t('arrive') + ' ' + formattedTime
      else if (departArrive === 'DEPART') timeStr = i18n.t('depart') + ' ' + formattedTime
    } else if (routingType === 'PROFILE') {
      timeStr = startTime +' ' + i18n.t('to') +' ' + endTime
    }

    let dateStr = timeStr != i18n.t('leaveNow') ?
      moment(date, OTP_API_DATE_FORMAT).calendar(null, { sameElse: dateFormat }) : null;

    if(dateStr?.indexOf(' at'))
      dateStr = dateStr.split(' at')[0];
     if(dateStr?.indexOf(' ב'))
      dateStr = dateStr.split(' ב')[0];
     if(dateStr?.indexOf(' בשעה'))
      dateStr = dateStr.split(' בשעה')[0];

  const summary = (
    <Stack spacing={2} direction={'row'}>
      {dateStr && (<Stack direction={'row'} spacing={0.5} alignItems={'center'}><i className='fa fa-calendar'/>
        <div>{dateStr}</div>
      </Stack>)}
      <Stack direction={'row'} spacing={0.5} alignItems={'center'}><i className='fa fa-clock-o'/>
        <div>{timeStr}</div>
      </Stack>
    </Stack>
  );

    return (
      <>
        <Tooltip title={i18n.t('editTravelTime')}>
          <Button sx={{color: isPopoverOpened? '#4B33A5' : '#4F4F4F', borderColor: isPopoverOpened? '#4B33A5' : '#EBEBEB', fontSize: 16, fontWeight: 400}} size={'small'} variant="outlined" onClick={props.onClick}
                  endIcon={isPopoverOpened ? (<ArrowDropUpIcon fontSize={'small'}/>) : (<ArrowDropDownIcon fontSize={'small'}/>)}>
            {summary}
          </Button>
        </Tooltip>
      </>
    )
}

const mapStateToProps = (state, ownProps) => {
  const { departArrive, date, time, routingType, startTime, endTime } = state.otp.currentQuery
  return {
    config: state.otp.config,
    routingType,
    departArrive,
    date,
    time,
    startTime,
    endTime,
    timeFormat: getTimeFormat(state.otp.config),
    dateFormat: getDateFormat(state.otp.config),
  }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(DateTimePreview)
